import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["control"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef } from 'react';
import clsx from 'clsx';
import ReactFlagsSelect from 'react-flags-select';
import { Controller } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var CountrySelectInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
      name = props.name,
      value = props.value,
      onChange = props.onChange,
      error = props.error,
      error_message = props.error_message,
      className = props.className,
      countries = props.countries,
      customLabels = props.customLabels,
      placeholder = props.placeholder,
      _props$searchPlacehol = props.searchPlaceholder,
      searchPlaceholder = _props$searchPlacehol === void 0 ? 'Search countries' : _props$searchPlacehol,
      disabled = props.disabled;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx('relative rounded-md border border-gray-300 pt-4 text-sm', "".concat(disabled ? 'bg-[#eaeaea]' : 'bg-white'), className),
      children: [/*#__PURE__*/_jsx(ReactFlagsSelect, {
        selected: value,
        onSelect: onChange,
        showSelectedLabel: true,
        searchable: true,
        className: "jv-country-select",
        searchPlaceholder: searchPlaceholder,
        placeholder: placeholder,
        countries: countries,
        customLabels: customLabels,
        disabled: disabled
      }), label && /*#__PURE__*/_jsx("label", {
        htmlFor: name,
        className: "origin-0 -z-1 absolute left-16 top-2 text-sm text-gray-600 transition-all peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-2  peer-focus:text-sm peer-focus:text-gray-600",
        children: label
      })]
    }), error && /*#__PURE__*/_jsx("p", {
      className: "text-red mt-2 text-sm",
      children: error_message
    })]
  });
});
export var CountrySelectInputControlled = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var control = _ref.control,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
    control: control
  }, props), {}, {
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          onChange = _ref2$field.onChange,
          value = _ref2$field.value,
          error = _ref2.fieldState.error;
      return /*#__PURE__*/_jsx(CountrySelectInput, _objectSpread(_objectSpread({
        ref: ref
      }, props), {}, {
        value: value,
        onChange: onChange,
        error: !!error,
        error_message: error === null || error === void 0 ? void 0 : error.message
      }));
    }
  }));
});
export default CountrySelectInput;